export default {
  groupName: 'walmart-retail',
  appName: 'Retail Category',
  baseRoute: '/dashboard/walmart-retail',
  label: 'Walmart - Retail Ad Effect Tracker Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Walmart - Retail Ad Effect Tracker Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/config/main.js